module.exports = __webpack_public_path__ + "img/app_ios.0db3e685.png";